var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"noPermission-box"},[_c('div',[_c('img',{attrs:{"src":_vm.noPermissionImg}}),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.text || _vm.defaultText))])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0a15db06","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/noPermission.vue
// module id = cvMu
// module chunks = 1